import TextCta from './TextCta';

export { type TextCtaProps } from './TextCta';
export default TextCta;
